import { Component, Input, OnInit, Output, ElementRef, Inject, ViewChild, NgZone } from "@angular/core";
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CompanyHttp } from "../../../../../tsScripts/providers/http/CompanyHttp";
import { SecurityModelDTO } from "../../../../../tsScripts/DTO/SecurityModelDTO";
import { ProfileDTO } from "./ProfileDTO";
import { MessageStorage } from "../../../../../tsScripts/util/MessageStorage";
import { ActivatedRoute } from "@angular/router";


@Component({
    templateUrl: "../../../../../views/components/support/companies/profile/modalAddProfile.html",
    providers: [CompanyHttp],
})
export class ModalAddProfile implements OnInit {
    errorMessage: string;
    listProfile: any[];
    listModel: any[];
    private companyId: string;
    public addProfile;

    modelSelected: SecurityModelDTO;
    profileSelected: ProfileDTO;

    loading: boolean;

    name = "";
    description = "";
    isActiveProfile;

    closeModal() {
        this.activeModal.close();
    }

    constructor(private CompanyHttp: CompanyHttp,
        private routeLocation: ActivatedRoute,
        private activeModal: NgbActiveModal,
        private sanitizer: DomSanitizer,
        private zone: NgZone) {
        this.companyId = this.routeLocation.snapshot.queryParams.companyId;
        this.isActiveProfile = false;
        this.errorMessage = "";
    }

    private getListModel() {
        this.errorMessage = "";
        this.CompanyHttp.listModelProfile(null).then((response) => {
            this.listModel = response.securityModels;
            this.listModel.unshift(new SecurityModelDTO("Seleccione un modelo"));
            this.modelSelected = this.listModel[0];
        }, (error) => {
            this.errorMessage = error.errorMessage;
        });
    }
    
    getListProfiles(value) {
        this.zone.run(() => {
            this.ListProfiles(value);
        });
    }


    private ListProfiles(value) {
        this.errorMessage = "";
        this.CompanyHttp.listProfiles({ modelId: value }).then((response) => {
            this.listProfile = response.profiles;
            this.listProfile.unshift(new ProfileDTO(null, "Seleccione un perfil", "", "", "", "", "", ""));
            this.profileSelected = this.listProfile[0];
        }, (error) => {
            this.errorMessage = error.errorMessage;
        });
    }

    processAddProfile() {
        this.loading = true;
        if (this.modelSelected.modelId != null) {
            if (this.profileSelected.profileId != "") {
                if (this.name != "") {
                    if (this.description != "") {
                        this.addProfile = {
                            "companyId": this.companyId,
                            "profileId": this.profileSelected.profileId,
                            "modelId": this.modelSelected.modelId,
                            "profileName": this.name,
                            "profileDescription": this.description
                            /*"isActive": ModalAddProfile.formatProcessActive(this.isActiveProfile)*/
                        };
                        this.CompanyHttp.processAddProfile(this.addProfile).then(() => {
                            this.loading = false;
                            MessageStorage.add("success", "La perfil ha sido agregado correctamente");

                            this.activeModal.dismiss();
                        }, (error) => {
                            this.loading = false;
                            this.zone.run(() => {
                                this.errorMessage = error.errorMessage;
                            });

                        });
                    } else {
                        this.errorMessage = "Descripción de perfil es obligatoria.";
                        this.loading = false;
                    }
                } else {
                    this.errorMessage = "Nombre de perfil es obligatorio.";
                    this.loading = false;
                }
            } else {
                this.errorMessage = "Debe seleccionar un perfil.";
                this.loading = false;
            }
        } else {
            this.errorMessage = "Debe seleccionar un modelo.";
            this.loading = false;
        }
    }

    public static formatProcessActive(active): string {
        let activeFormated;
        switch (active) {

            case true:
                activeFormated = "1";
                break;

            case false:
                activeFormated = "0";
                break;
        }
        return activeFormated;

    }

    getNameDescription() {
        this.name = this.profileSelected.profileName;
        this.description = this.profileSelected.description;
    }

    ngOnInit() {
        this.zone.run(() => {
            this.getListModel();
        });
    }
}